module.exports = __webpack_public_path__ + "static/media/AP_Normal_Z1.a5cef7ef.png";